import { CheckoutSourceRef } from '@domgen/checkout-sdk-types/checkout-be/src/schemas/channelSource';
import { CheckoutBasket } from '../../models/checkout/checkout-basket.interface';
import { mockCheckoutOffers } from './checkout-offers.mock';

export const mockCheckoutBasket: CheckoutBasket = {
  channelSourceData: {
    checkoutSourceRef: 'gc_e2e_testing' as CheckoutSourceRef,
  },
  offers: mockCheckoutOffers,
};
